<template>
    <el-dialog title="选择文件" :visible.sync="formVisible" :close-on-click-modal="true" width="80%">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="listQuery">
                <el-form-item>
                    <el-input v-model="listQuery.q" placeholder="搜索"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="listQuery.isme">只看自己</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getList()">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px;">
            <el-table :data="tableData" v-loading="listLoading" element-loading-text="Loading" border highlight-current-row
                ref="dataTable">
                <!-- <el-table-column label="状态" align="center" width="100px">
                                <template slot-scope="{row}">
                                <span>{{ row.Stats }}</span>
</template>
                        </el-table-column> -->
                <el-table-column label="名称" align="left">
                    <template slot-scope="{row}">
                        <span v-if="row.Status < 1">{{ row.Name }}</span>
                        <a :href="'http://jazpan.com/view/' + row.Id" target="_blank" v-else>
                            <img class="flicon" :src="$ApiUrl + '/icon?name=' + row.Extion" />{{ row.Name }}
                        </a>
                    </template>
                </el-table-column>
                <el-table-column label="作者" align="center" width="120px">
                    <template slot-scope="{row}">
                        <a :href="'http://jazpan.com/user/' + row.Uid" target="_blank">{{ row.Nick }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="金额" align="center" width="100px">
                    <template slot-scope="{row}">
                        <span style="color:#f60;font-weight:bold">{{ row.Amounts }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="大小" align="center" width="120px">
                    <template slot-scope="{row}">
                        <span>{{ getFlSize(row.Size) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="时间" align="center" width="160px">
                    <template slot-scope="{row}">
                        <span>{{ row.Timestr }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200px">
                    <template slot-scope="{row}">
                        <el-button-group>
                            <el-button size="small" type="primary" @click="handlerAdd(row)"
                                :disabled="row.InBox">添加</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align:right;margin-top:50px;">
                <el-pagination background layout="prev, pager, next" @current-change="getList" :current-page="pgpage"
                    :page-count="pgpages">
                </el-pagination>
            </div>
        </el-col>
        <!--工具条-->
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="formVisible = false">完成</el-button>
            <!-- <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button> -->
        </div>
    </el-dialog>
</template>


<script>
import util from '@/common/js/util'
export default {
    data() {
        return {
            boxid: '',
            formVisible: false,
            formLoading: false,
            listLoading: false,
            pgpage: 1,
            pgpages: 1,
            listQuery: {},
            tableData: []
        }
    },
    mounted() {
        // this.getList();
    },
    methods: {
        show(bid) {
            if (!bid || bid == '') return;
            this.boxid = bid;
            this.pgpage = 1;
            this.pgpages = 1;
            this.listQuery = {
                q: '',
                isme: true,
                page: 1
            };
            this.formVisible = true;
            this.getList();
        },
        getFlSize: util.getFlSize,
        getList(pg) {
            this.listLoading = true;
            let pars = this.listQuery;
            pars.boxid = this.boxid;
            pars.page = pg || this.pgpage;
            this.$post('/user/fl/page', pars).then(res => {
                console.log('fls:', res);
                this.listLoading = false;
                this.pgpage = res.data.Page;
                this.pgpages = res.data.Pages;
                this.tableData = res.data.Data;
                // this.$message('退出成功');
            }).catch(err => {
                this.listLoading = false;
                this.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });
            });
        },
        handlerAdd(et) {
            this.$post('/user/boxinfoup', { boxid: this.boxid, xid: et.Xid, sort: 10, isadd: true }).then(res => {
                et.InBox = true;
                this.$message('添加成功');
                this.$emit('submitOK');
            }).catch(err => {
                this.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });
            });
        }
    }
};
</script>

<style scoped>
.tmpdesc {
    margin-left: 10px;
    color: #d0d0d0;
}
</style>




// WEBPACK FOOTER //
// FileSelForm.vue?99b08f72